import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';

import { ButtonBox } from '../../../../../../components/UI/Box';
import { IconAttachFileMS } from '../../../../../../constants/icons';
import {
  isRichTextEmpty,
  RichTextEditor,
} from '../../../../../Announcements/components/RichTextEditor';
import {
  DialogContainer,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../styles';

interface ApproveMenuProps {
  docId: number;
  name: string;
  document: string;
  docLoading: boolean;
  disabled: boolean;
  handleApprove: (docId?: number) => Promise<void>;
  handleApproveWithReservation: (
    reservationNote: string,
    docId: number
  ) => Promise<void>;
}

export function ApproveMenu({
  docId,
  name,
  document,
  docLoading,
  disabled,
  handleApprove,
  handleApproveWithReservation,
}: ApproveMenuProps): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [note, setNote] = useState('');

  const isMenuOpen = Boolean(anchorEl);
  const openMenu = (e: React.MouseEvent<HTMLButtonElement>): void =>
    setAnchorEl(e.currentTarget);
  const closeMenu = (): void => setAnchorEl(null);

  const closeDialog = (): void => setOpenDialog(false);

  const isEmpty = isRichTextEmpty(note);

  const handleDirect = (): void => {
    closeMenu();
    handleApprove(docId);
  };

  const handleOpenReservation = (): void => {
    closeMenu();
    setOpenDialog(true);
  };

  const handleConfirm = (): void => {
    handleApproveWithReservation(note, docId).then(() => closeDialog());
  };

  return (
    <>
      <Button
        disabled={docLoading || disabled}
        sx={{ maxWidth: '120px', height: '40px' }}
        onClick={openMenu}
      >
        aprovar
      </Button>
      <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={closeMenu}>
        <MenuItem onClick={handleDirect}>Aprovar direto</MenuItem>
        <MenuItem onClick={handleOpenReservation}>
          Aprovar com ressalvas
        </MenuItem>
      </Menu>
      <StyledDialog open={openDialog} onClose={closeDialog}>
        <DialogContainer>
          <Typography>
            O documento <span style={{ fontWeight: '600' }}>{name}</span> será
            aprovado com ressalvas.
          </Typography>
          <TextTypography>
            {IconAttachFileMS}
            {document}
          </TextTypography>
          <RichTextEditor
            value={note}
            onChange={setNote}
            placeholder="Descreva a ressalva e o que precisa ser ajustado"
            charLimit={2000}
          />
          <Typography sx={{ fontSize: '13px', color: 'common.grey' }}>
            Esta observação ficará visível para quem enviou o documento.
          </Typography>
          <ButtonBox gap={2} my={2.5}>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={docLoading || isEmpty}
              onClick={handleConfirm}
            >
              aprovar com ressalvas
            </Button>
            <OutlinedButton
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={closeDialog}
            >
              cancelar
            </OutlinedButton>
          </ButtonBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
